import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  Box,
} from "@mui/material";
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from '../../../hooks/useResponsive'

const GreenText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.oldprimary.main,
  };
});

const BlueText = styled('span')(({ theme }) => {
  return {
    color: theme.palette.info.main,
  };
});

const ListStyle = styled('ul')(({ theme }) => {
  return {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
  }
});

const ListItemStyle = styled('li')(({ theme }) => {
  return {
    ...theme.typography.body2,
  }
});


export default function Before3WayCheckPrepDialog({ isOpen, closeDialog, checkList, prepList }) {
  const smUp = useResponsive('up', 'sm');
  const checkListText = checkList?.split('\r\n');
  const prepListText = prepList?.split('\r\n');

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          사전 미팅때 꼭 준비, 확인해주세요!
        </Typography>
        <Typography variant="body2" sx={{ wordBreak: "keep-all", mb: 3 }}>
          사전 미팅 전에 카카오톡으로 리마인드 드릴게요.
        </Typography>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            mb: 2,
            backgroundColor: (theme) => theme.palette.background.neutral,
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            🙋‍♀️ 미팅때 꼭 <GreenText>확인</GreenText>해주세요!
          </Typography>
          <ListStyle>
          {checkListText?.map((text, index) => (
            <ListItemStyle key={index}>
              {text}
            </ListItemStyle>
          ))}
          </ListStyle>
        </Box>
        <Box
          sx={{
            p: { xs: 2, sm: 3 },
            backgroundColor: (theme) => theme.palette.background.neutral,
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" gutterBottom>
            🧑🏻‍💻 미팅때 꼭 <BlueText>준비</BlueText>해주세요!
          </Typography>
          <ListStyle>
          {prepListText?.map((text, index) => (
            <ListItemStyle key={index}>
              {text}
            </ListItemStyle>
          ))}
          </ListStyle>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="large"
          sx={{ px: 3 }}
          fullWidth={!smUp}
          onClick={closeDialog}
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
};
